export default "__VITE_ASSET__D3hJ15j8__";